export const quidgetSrcInit = 'https://w.quidget.ai/quidget.loader.js';
export const quidgetIdInit = 'f6dba67c-5a2d-4f20-84f4-eb3ec9cc7669';
export const quidgetIdInit2 = '8fdad8b3-a68b-413d-b2d4-7988c5ce2f36';
export const defaultQuidgetOption = '{}';
export const quidgetOptionDemo = `{"chatView":"permanent"}`;
